import { set, when } from 'cerebral/operators'
import { state, props } from 'cerebral/tags'
import { parallel } from 'cerebral'
/*
 * Will remove focusedOption that is set onMouseEnter when hovering
*/
export default [
  parallel([
    set(state`selectr.${props`namespace`}.focusedOption`, null),
    //set(state`selectr.${props`namespace`}.focusInput`, true),
    when(
      state`selectr.${props`namespace`}.input.value`,
      value => value.length > 0
    ),
    {
      true: [set(state`selectr.${props`namespace`}.optionsClosed`, false)],
      false: []
    }
  ])
]
